import {
  dermatology_main_steps,
  dermatology_sub_steps,
  step_status,
} from "helpers/enum";
import { setNextScreenToUpcoming } from "helpers/setDermatologyStepStatus";

export const dermaBasicInfoReducer = {
  select_patient(state, action) {
    const { value, prevScreen, nextScreen, status, isValid } = action.payload;
    if (prevScreen) {
      state.subSteps[dermatology_sub_steps.select_patient].prevScreen =
        prevScreen;
    }
    if (nextScreen) {
      state.subSteps[dermatology_sub_steps.select_patient].nextScreen =
        nextScreen;
    }
    if (value) {
      state.subSteps[dermatology_sub_steps.select_patient].value = value;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.select_patient].isValid = isValid;
    }
    if (status) {
      state.subSteps[dermatology_sub_steps.select_patient].status = status;
      if (status === step_status.completed) {
        setNextScreenToUpcoming({
          state,
          status,
          nextScreen: dermatology_sub_steps.confirm_residence,
        });
      }
    }
  },
  select_child(state, action) {
    const { value, isValid } = action.payload;
    if (value) {
      state.subSteps[dermatology_sub_steps.select_child].value = value;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.select_child].isValid = isValid;
    }
  },
  select_ward(state, action) {
    const { value, isValid } = action.payload;
    if (value) {
      state.subSteps[dermatology_sub_steps.select_ward].value = value;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.select_ward].isValid = isValid;
    }
  },
  select_someone_else(state, action) {
    const { value, isValid } = action.payload;
    if (value) {
      state.subSteps[dermatology_sub_steps.select_someone_else].value = value;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.select_someone_else].isValid =
        isValid;
    }
  },
  confirm_residence(state, action) {
    const { value, status, isValid, prevScreen } = action.payload;
    if (value) {
      state.subSteps[dermatology_sub_steps.confirm_residence].value = value;
    }
    if (prevScreen) {
      state.subSteps[dermatology_sub_steps.confirm_residence].prevScreen =
        prevScreen;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.confirm_residence].isValid = isValid;
    }
    if (status) {
      state.subSteps[dermatology_sub_steps.confirm_residence].status = status;
      if (status === step_status.completed) {
        setNextScreenToUpcoming({
          state,
          status,
          nextScreen: dermatology_sub_steps.patient_bio,
        });
      }
    }
  },
  patient_bio(state, action) {
    const { value, status, isValid, prevScreen } = action.payload;
    if (value) {
      state.subSteps[dermatology_sub_steps.patient_bio].value = value;
    }
    if (prevScreen) {
      state.subSteps[dermatology_sub_steps.patient_bio].prevScreen = prevScreen;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.patient_bio].isValid = isValid;
    }
    if (status) {
      state.subSteps[dermatology_sub_steps.patient_bio].status = status;
      if (status === step_status.completed) {
        setNextScreenToUpcoming({
          state,
          status,
          nextScreen: dermatology_sub_steps.identity_confirmation,
        });
      }
    }
  },
  identity_confirmation(state, action) {
    const { value, prevScreen, isValid, status } = action.payload;
    if (prevScreen) {
      state.subSteps[dermatology_sub_steps.identity_confirmation].prevScreen =
        prevScreen;
    }
    if (value) {
      state.subSteps[dermatology_sub_steps.identity_confirmation].value = value;
    }
    if (isValid !== undefined) {
      state.subSteps[dermatology_sub_steps.identity_confirmation].isValid =
        isValid;
    }
    if (status) {
      state.subSteps[dermatology_sub_steps.identity_confirmation].status =
        status;
      if (status === step_status.completed) {
        state.mainSteps[dermatology_main_steps.basic_info].status =
          step_status.completed;
        if (
          state.mainSteps[dermatology_main_steps.visit_details].status ===
          step_status.upcoming
        ) {
          state.mainSteps[dermatology_main_steps.visit_details].status =
            step_status.current;
        }
        setNextScreenToUpcoming({
          state,
          status,
          nextScreen: dermatology_sub_steps.select_condition,
        });
      }
    }
  },
};
